/** The two faces of the Decide page, as a two-option radio group: "Walk me through" and "Full sheet". */
import { RovingGroup } from "../../theme/roving";
import type { Face } from "./useFace";

const FACES: readonly { readonly value: Face; readonly label: string }[] = [{ value: "walk", label: "Walk me through" }, { value: "sheet", label: "Full sheet" }];

export function FaceSwitch({ face, onChange }: { readonly face: Face; readonly onChange: (face: Face) => void }) {
  return (
    <RovingGroup className="gx-segmented gx-face" role="radiogroup" aria-label="How to work through the decisions" data-testid="decide.face">
      {FACES.map((f) => (
        <button key={f.value} type="button" role="radio" aria-checked={f.value === face} className="gx-segment" data-testid={`decide.face.${f.value}`} onClick={() => onChange(f.value)}>
          <span>{f.label}</span>
        </button>
      ))}
    </RovingGroup>
  );
}
